"use client";
async function c(t, e, n, r) {
  const o = `${r}/conversations`, i = {
    id: t || void 0,
    type: "openai",
    ...e
  }, s = await fetch(o, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${n}`
    },
    body: JSON.stringify(i)
  });
  if (!s.ok) {
    const a = await s.text();
    throw new Error(`Failed to log conversation: ${a}`);
  }
  return s.json();
}
async function p(t, e, n) {
  const r = `${n}/conversations/${t}`, o = await fetch(r, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${e}`
    }
  });
  if (!o.ok) {
    const i = await o.text();
    throw new Error(`Failed to get conversation: ${i}`);
  }
  return o.json();
}
export {
  p as getConversation,
  c as logConversation
};
